import { BaseNode } from './BaseNode';

export function TransformNode({ data }: { data: Record<string, unknown> }) {
  const fieldCount = Object.keys(data).filter(k => k !== 'label' && k !== 'alias').length;

  return (
    <BaseNode
      type="transform"
      label={data.label}
      alias={data.alias as string | undefined}
      lines={[fieldCount > 0 && { text: `${fieldCount} field${fieldCount !== 1 ? 's' : ''}` }]}
    />
  );
}
